import { AppState } from "../../../redux-configuration/AppState";
import { Company } from "../../../company/domain/entity/company";

export const loadBusinessByCodeLoadingSelector =  (appState: AppState): boolean => appState.registration.loadBusiness.loading
export const loadBusinessByCodeErrorSelector = (appState: AppState): string | undefined => appState.registration.loadBusiness.error
export const loadedBusinessByCodeSelector = (appState: AppState): Company | null => appState.registration.loadBusiness.business
